<template>
    <v-card class="pa-3 ma-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-ticket-account</v-icon
            >
            <pre><v-toolbar-title><h2>Tickets</h2></v-toolbar-title></pre>
        </v-toolbar>
        <loader :loading="isloading"></loader>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="'/'"
                    :loading="isloading"
                    :disabled="isloading"
                    color="blue"
                    class="mt-2 mx-3"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-arrow-left-bold-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Volver</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="openNewTicketDialog"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus-box</v-icon>
                </v-btn>
            </template>
            <span>Nuevo Ticket</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="toggleView"
                    :loading="isloading"
                    :disabled="isloading"
                    :color="viewMode === 'kanban' ? 'grey darken-2' : '#1F1C91'"
                    class="mt-2 mx-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">{{
                        viewMode === 'kanban'
                            ? 'mdi-view-list'
                            : 'mdi-view-column'
                    }}</v-icon>
                </v-btn>
            </template>
            <span>{{
                viewMode === 'kanban'
                    ? 'Vista de Listado'
                    : 'Vista Kanban'
            }}</span>
        </v-tooltip>
        <v-tooltip right v-if="viewMode === 'kanban'">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="toggleFinalizados"
                    :loading="isloading"
                    :disabled="isloading"
                    :color="mostrarFinalizados ? 'green' : 'grey lighten-1'"
                    class="mt-2 mx-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">{{
                        mostrarFinalizados
                            ? 'mdi-check-circle'
                            : 'mdi-check-circle-outline'
                    }}</v-icon>
                </v-btn>
            </template>
            <span>{{
                mostrarFinalizados
                    ? 'Ocultar Finalizados'
                    : 'Mostrar Finalizados'
            }}</span>
        </v-tooltip>
        <v-row class="mx-2 my-2">
            <v-row>
                <v-col cols="6" justify="center">
                    <FilterComponentVue
                        :headers="filter_headers"
                        v-model="filtros_prueba"
                    ></FilterComponentVue>
                </v-col>
                <v-col cols="6" class="d-flex align-center justify-end">
                    <v-switch
                        v-model="soloMisTicketsCreados"
                        label="Tickets creados por mí"
                        color="#1F1C91"
                        class="mt-0"
                        @change="handleSoloMisTicketsChange"
                    ></v-switch>
                </v-col>
            </v-row>
        </v-row>

        <!-- Vista Kanban -->
        <TicketKanbanVue
            v-if="viewMode === 'kanban'"
            :items="kanbanItems"
            :loading="kanbanLoading"
            :mostrar-finalizados="mostrarFinalizados"
            @ticket-updated="refreshKanbanData"
            @ticket-estado-cambiado="handleTicketEstadoCambiado"
            @open-ticket="openEditTicketDialog"
            class="mb-4"
        />

        <!-- Vista de Listado -->
        <TicketDataTableVue
            v-show="viewMode === 'list'"
            ref="ticketDataTable"
            :filtros="filtros_prueba"
            :actions="edit"
            @update:filtros="updateFiltros"
            @open-ticket="openEditTicketDialog"
        />

        <!-- Dialog para crear/editar ticket -->
        <TicketDialogVue
            v-model="ticketDialog"
            :ticket-id="selectedTicketId"
            @ticket-saved="handleTicketSaved"
            @comentarios-leidos="handleComentariosLeidos"
            @close="handleTicketDialogClose"
        />
    </v-card>
</template>
<script>
import debounce from "lodash/debounce";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import TicketDataTableVue from "../../../components/ticket/TicketDataTable.vue";
import TicketKanbanVue from "../../../components/ticket/TicketKanban.vue";
import TicketDialogVue from "../../../components/ticket/TicketDialog.vue";
import { mapGetters } from "vuex";

export default {
    mixins: [],

    components: {
        FilterComponentVue,
        TicketDataTableVue,
        TicketKanbanVue,
        TicketDialogVue,
    },
    data() {
        return {
            viewMode: 'kanban', // 'kanban' o 'list'
            kanbanItems: [],
            kanbanLoading: false,
            mostrarFinalizados: false,
            soloMisTicketsCreados: false,
            ticketDialog: false,
            selectedTicketId: null,
            savedScrollPosition: 0,
            savedKanbanScroll: { x: 0, y: 0 },
            filtros_prueba: {
                search: "",
                estado: {},
                fecha: {},
                fecha_fianlizacion: {},
                departamento: {},
                urgencia: {},
                cliente: {},
                responsable: {},
                proyecto: {},
            },
            filter_headers: [
                {
                    title: "Cliente",
                    type: "cliente",
                    active: false,
                    model: "cliente",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Proyecto",
                    type: "select",
                    active: false,
                    model: "proyecto",
                    item_text: "nombre",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Fecha de creación",
                    type: "date",
                    active: true,
                    model: "fecha",
                },
                {
                    title: "Fecha de finalización",
                    type: "date",
                    active: true,
                    model: "fecha_fianlizacion",
                },
                {
                    title: "Estado",
                    type: "select",
                    active: false,
                    model: "estado",
                    item_text: "descripcion",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Departamento",
                    type: "select",
                    active: false,
                    model: "departamento",
                    item_text: "descripcion",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Urgencia",
                    type: "select",
                    active: false,
                    model: "urgencia",
                    item_text: "descripcion",
                    item_value: "id",
                    items: [],
                },
            ],

            toggle_exclusive: 0,

            userId: localStorage.getItem("user_id"),
        };
    },
    created() {
        // console.log('Tickets component created - userRole:', this.userRole);
        // console.log('Store state:', this.$store.state.auth);

        if (this.userId == "164") {
            this.filtros_prueba.responsable = {
                nombre: localStorage.getItem("user_name"),
                value: localStorage.getItem("user_id"),
            };
        }

        this.getEstados();
        this.getDepartamentos();
        this.getUrgencia();
        this.getProyectos();

        if (this.edit) {
            this.filter_headers.push({
                title: "Responsable",
                type: "select",
                active: false,
                model: "responsable",
                item_text: "nombre",
                item_value: "id",
                items: [],
            });

            this.getResponsables();

            this.filtros_prueba.responsable = {
                nombre: localStorage.getItem("user_name"),
                value: localStorage.getItem("user_id"),
            };
        }

        // Cargar datos iniciales del Kanban
        this.loadKanbanData();
    },
    mounted() {
        this.loadFiltros();
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: debounce(function (n) {
                // Actualizar vista Kanban cuando cambien los filtros
                if (this.viewMode === 'kanban') {
                    this.loadKanbanData();
                }
            }, 500),
        },
    },
    methods: {
        // Metodos que lista las opciones de los filtros
        getProyectos() {
            axios.get("api/get-proyectos-activos").then((res) => {
                this.filter_headers[1].items = res.data;
            });
        },
        getEstados() {
            axios.get("api/get-estado-tickets").then((res) => {
                this.filter_headers[4].items = res.data.success;
            });
        },
        getDepartamentos() {
            axios.get("api/get-departamentos").then((res) => {
                this.filter_headers[5].items = res.data.success;
            });
        },
        getUrgencia() {
            axios.get("api/get-urgencia").then((res) => {
                this.filter_headers[6].items = res.data.success;
            });
        },
        getResponsables() {
            axios.post("api/get-usuarios-empleados-all").then((res) => {
                this.filter_headers[7].items = res.data.users;
            });
        },

        // Establecer los valores del filtro
        updateFiltros(newFiltros) {
            // this.filtros_prueba = newFiltros
            this.saveFiltros(newFiltros);
        },

        loadFiltros() {
            const filtros_modulo = this.$store.getters.get_filtros.tickets;
            if (filtros_modulo != null) {
                // this.page = filtros_modulo.page;
                // this.itemsPerPage = filtros_modulo.itemsPerPage;

                if (filtros_modulo.filtros == null) {
                    this.filtros_prueba.responsable = {
                        nombre: localStorage.getItem("user_name"),
                        value: localStorage.getItem("user_id"),
                    };
                } else {
                    this.filtros_prueba = filtros_modulo.filtros;
                }
                //this.getAllTickets();
            }
        },

        saveFiltros(newFiltros) {
            this.$store.dispatch("setFiltros", {
                name: "tickets",
                filtros: {
                    filtros: newFiltros.filtros,
                    page: newFiltros.page,
                    itemsPerPage: newFiltros.itemsPerPage,
                },
            });
        },

        // Métodos para la vista Kanban
        toggleView() {
            this.viewMode = this.viewMode === 'kanban' ? 'list' : 'kanban';
            if (this.viewMode === 'kanban') {
                this.loadKanbanData();
            }
        },

        loadKanbanData() {
            // No recargar si ya está cargando
            if (this.kanbanLoading) return;
            
            this.kanbanLoading = true;

            let params = {
                fecha_inicio: this.filtros_prueba.fecha?.start,
                fecha_fin: this.filtros_prueba.fecha?.end,
                fecha_fianlizacion_inicio:
                    this.filtros_prueba.fecha_fianlizacion?.start,
                fecha_fianlizacion_fin:
                    this.filtros_prueba.fecha_fianlizacion?.end,
                responsable: this.filtros_prueba.responsable?.value,
                departamento: this.filtros_prueba.departamento?.value,
                urgencia: this.filtros_prueba.urgencia?.value,
                cliente: this.filtros_prueba.cliente?.value,
                id_proyecto: this.filtros_prueba.proyecto?.value,
                search: this.filtros_prueba.search,
                // Parámetros especiales para Kanban
                kanban: true, // Indicador de que es vista kanban
                all: true, // Obtener todos los tickets sin paginar
                incluir_finalizados: this.mostrarFinalizados ? 1 : 0, // Incluir o no finalizados
                solo_creados_por_mi: this.soloMisTicketsCreados ? 1 : 0, // Filtrar por creador
            };

            return axios
                .get('api/get-tickets', { params: params })
                .then((res) => {
                    this.kanbanItems = res.data.data || res.data;
                })
                .catch((err) => {
                    console.error('Error al cargar datos del kanban:', err);
                })
                .finally(() => {
                    this.kanbanLoading = false;
                });
        },

        handleSoloMisTicketsChange() {
            if (this.viewMode === 'kanban') {
                this.loadKanbanData();
            } else {
                // Refrescar el data table
                if (this.$refs.ticketDataTable) {
                    this.$refs.ticketDataTable.getItems();
                }
            }
        },

        toggleFinalizados() {
            this.mostrarFinalizados = !this.mostrarFinalizados;
            this.loadKanbanData();
        },

        refreshKanbanData() {
            this.loadKanbanData();
            // También refrescar la tabla si está visible
            if (this.$refs.ticketDataTable) {
                this.$refs.ticketDataTable.getItems();
            }
        },

        handleTicketEstadoCambiado(payload) {
            // Actualizar localmente el estado del ticket en kanbanItems
            const ticket = this.kanbanItems.find(t => t.id === payload.ticketId);
            if (ticket) {
                ticket.id_estado_ticket = payload.nuevoEstado;
                // Forzar actualización reactiva
                this.$set(this.kanbanItems, this.kanbanItems.indexOf(ticket), ticket);
            }
        },

        // Métodos para el dialog de tickets
        saveListScrollPosition() {
            this.savedScrollPosition = window.scrollY || 0;
            if (this.viewMode === 'list' && this.$refs.ticketDataTable) {
                this.$refs.ticketDataTable.saveScrollPosition();
            }
            if (this.viewMode === 'kanban') {
                const kanban = document.querySelector('.kanban-container');
                this.savedKanbanScroll = {
                    x: kanban?.scrollLeft || 0,
                    y: window.scrollY || 0,
                };
            }
        },

        restoreListScrollPosition() {
            this.$nextTick(() => {
                if (this.viewMode === 'list' && this.$refs.ticketDataTable) {
                    this.$refs.ticketDataTable.restoreScrollPosition();
                } else if (this.viewMode === 'kanban') {
                    const kanban = document.querySelector('.kanban-container');
                    if (kanban) {
                        kanban.scrollLeft = this.savedKanbanScroll.x || 0;
                    }
                    window.scrollTo(0, this.savedKanbanScroll.y || 0);
                } else {
                    window.scrollTo(0, this.savedScrollPosition || 0);
                }
            });
        },

        openNewTicketDialog() {
            this.saveListScrollPosition();
            this.selectedTicketId = null;
            this.ticketDialog = true;
        },

        openEditTicketDialog(ticketId) {
            this.saveListScrollPosition();
            this.selectedTicketId = ticketId;
            this.ticketDialog = true;
        },

        handleTicketSaved() {
            if (this.viewMode === 'kanban') {
                this.loadKanbanData().finally(() => {
                    this.restoreListScrollPosition();
                });
            } else if (this.$refs.ticketDataTable) {
                this.$refs.ticketDataTable.getItems(() => {
                    this.restoreListScrollPosition();
                });
            }
        },

        handleComentariosLeidos(ticketId) {
            const ticket = this.kanbanItems.find((t) => t.id === ticketId);
            if (ticket) {
                ticket.tiene_comentarios_no_leidos = false;
            }
            if (this.$refs.ticketDataTable) {
                const row = this.$refs.ticketDataTable.items.find(
                    (t) => t.id === ticketId
                );
                if (row) {
                    row.tiene_comentarios_no_leidos = false;
                }
            }
        },

        handleTicketDialogClose() {
            this.selectedTicketId = null;
            this.restoreListScrollPosition();
        },
    },
    computed: {
        ...mapGetters({
            userRole: "auth/userRole",
        }),
        edit: function () {
            const role = this.userRole;
            // console.log("Edit computed - role:", role);
            return (
                role == 1 ||
                role == 5 ||
                role == 9 ||
                role == 7 ||
                role == 6 ||
                role == 12
            );
        },
        role: function () {
            return this.userRole;
        },
        isloading: function () {
            return this.$store.getters.getloading;
        },
        user: function () {
            const user = this.$store.getters.getuser;
            return user;
        },
    },
};
</script>
